<template>
  <div>
    <div
      style="position: relative"
      v-for="(item2, index2) in commList"
      :key="index2"
    >
      <div class="avatar-level2">
        <el-avatar :size="sizeList[2]" :src="circleUrl"></el-avatar>
      </div>
      <div class="comm-detail">
        <span class="name">{{ item2.replied_name }}</span> 回复
        <span class="name"> @{{ item2.displayname }}</span> 的评论
        <div class="cont">{{ item2.cont }}</div>
        <div class="date">
          {{ dateFormat(item2.create_date)
          }}<a href="##" v-on:click="replyShow($event, item2.replied_name)"
            >回复</a
          >
          <!-- <a href="#">举报</a> -->
          <!-- <a href="#">删除</a> -->
        </div>
        <div class="replyarea">
          <el-input
            type="textarea"
            :placeholder="placeHolder"
            :rows="4"
            v-model="rplcont2"
            maxlength="120"
            show-word-limit
          >
          </el-input>
          <div class="replybtns">
            <el-button
              type="primary"
              @click="
                reply(
                  $event,
                  item2.id,
                  item2.comment_id,
                  item2.replied_name,
                  item2.uid,
                  2
                )
              "
              plain
              >发表回复</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <a
      class="load-more"
      href="javascript:void(0);"
      v-show="isShowMoreBtn"
      @click="loadMore()"
      >查看更多回复</a
    >
  </div>
</template>
<style scoped>
/*回复评论*/
.comm-cont {
  border-bottom: #e2e2e2 1px solid;
  margin-top: 32px;
  position: relative;
  padding-bottom: 32px;
}
.avatar {
  display: inline-block;
  position: absolute;
  left: 0;
}
.comm-level2 {
  margin-left: 45px;
  margin-top: 12px;
  position: relative;
}
.avatar-level2 {
  display: inline-block;
  position: absolute;
  left: 12px;
  top: 2px;
}
.avatar {
  vertical-align: middle;
  padding-top: 8px;
}
.comm-detail {
  margin-left: 55px;
}
.date,
.date a {
  color: #999;
  font-size: 14px;
}
.date a {
  margin-left: 16px;
}
.name {
  color: #757575;
  font-size: 14px;
}
.mr-10 {
  margin-right: 10px;
}
.ml-20 {
  margin-left: 20px;
}
.cont {
  padding: 16px 0 16px 0;
}
.comm-num {
  color: #999;
  font-size: 14px;
  font-weight: normal;
}
.see-comm {
  color: #00a1d6;
  margin-left: 16px;
  font-size: 14px;
}
a:hover {
  color: #00a1d6;
}
.ava-check {
  float: left;
  padding: 8px;
  padding-right: 16px;
}
.replybtns {
  text-align: right;
  padding-top: 8px;
}
.replyarea {
  max-width: 800px;
  margin-top: 8px;
  display: none;
}
.load-more {
  font-size: 14px;
  padding: 16px 8px 8px 55px;
  display: block;
}
</style>
<script>
export default {
  data() {
    return {
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      squareUrl:
        "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
      sizeList: ["large", "medium", "small"],
      totalCount: 0,
      pageIndex: 1,
      commList: [],
      isShowMoreBtn: true,
      rplcont: "",
      rplcont2: "",
      placeHolder: "",
      loginuid: 0,
    };
  },
  props: ["commentId", "childCommentCount", "id"],
  mounted() {
    var _uid = localStorage.getItem("loginuid");
    this.loginuid = _uid == null || _uid == undefined ? 0 : parseInt(_uid);
  },
  methods: {
    loadMore() {
      this.getCommentList(this.commentId);
    },
    dateFormat(date) {
      return date.replace("T", " ").split(".")[0];
    },
    getCommentList(comment_id) {
      //获取二级评论
      this.$http
        .get("/api/CommentView/" + this.pageIndex + "/" + comment_id + "/2")
        .then((r) => {
          if (r.data.code == 200) {
            //合并数组
            this.commList.push.apply(this.commList, r.data.data);
            this.isShowMoreBtn = this.commList.length < this.childCommentCount;
          } else {
            this.$alert("获取数据失败，请重试", "", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
      this.pageIndex++;
    },
    reply(e, pid, commid, disname, uid, replyType) {
      if (this.loginuid == 0) {
        //未登录
        this.$alert("请先登录", "", {
          confirmButtonText: "确定",
        });
        return;
      }

      var cont = this.rplcont;
      if (replyType == 2) {
        //回复别人的评论
        cont = this.rplcont2;
        if (this.rplcont2 == "") {
          this.$alert("请填写内容", "", {
            confirmButtonText: "确定",
          });
          return;
        }
      } else {
        //发表新的评论
        if (this.rplcont == "") {
          this.$alert("请填写内容", "", {
            confirmButtonText: "确定",
          });
          return;
        }
      }
      //var _articleId = this.id;
      this.$http
        .post("/api/PlayerDetailComment/", {
          cont: cont,
          parent_id: pid,
          comment_id: commid,
          cont_id: this.id,
          replied_uid: uid,
          replied_name: disname,
        })
        .then((r) => {
          console.log(r);
          if (r.data.code == 200) {
            if (replyType == 2) {
              this.rplcont2 = "";
            } else {
              this.rplcont = "";
            }
            this.$alert("评论成功", "", {
              confirmButtonText: "确定",
            });
            if (pid > 0) {
              this.replyShow2(e);
            }
            this.commList.push(r.data.data);
            //this.getCommentList(_articleId);
          } else {
            this.$alert("获取数据失败，请重试", "", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    replyShow: function (e, placeHolderStr) {
      //显示和隐藏文本框
      var cur = e.currentTarget;
      var displayArea = cur.parentNode.nextSibling;
      var disstate = displayArea.style.display;
      if (disstate === "" || disstate === "none") {
        displayArea.style.display = "block";
        this.placeHolder = "@" + placeHolderStr;
      } else {
        displayArea.style.display = "none";
      }
    },
    replyShow2: function (e) {
      //显示和隐藏文本框（第三级的评论框）
      var cur = e.target;
      var displayArea = cur.parentNode.parentNode;
      var disstate = displayArea.style.display;
      if (disstate === "" || disstate === "none") {
        displayArea.style.display = "block";
      } else {
        displayArea.style.display = "none";
      }
    },
  },
};
</script>
